const storageKey = 'servicezone.pendingWrites.v2';
export const requestId = () => {
  const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  return Array.from(bytes, (b, i) => ([4, 6, 8, 10].includes(i) ? '-' : '') + b.toString(16).padStart(2, '0')).join('');
};
const load = () => { try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_) { return {}; } };
const hash = async value => {
  const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(value)));
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
};
export const pendingWrite = async (url, data, token, resolve) => {
  const values = data instanceof FormData ? await Promise.all(Array.from(data.entries()).map(async ([key,value])=>[key,value instanceof File ? {name:value.name,size:value.size,modified:value.lastModified,bytes:Array.from(new Uint8Array(await value.arrayBuffer()))} : value])) : data;
  // Persist only digests and UUIDs; a changed payload cannot bypass an unresolved payment.
  const [fingerprint,scope] = await Promise.all([hash([url, values, token]),hash([url,token])]);
  const journal = load();
  const previous = journal[scope];
  if (previous && previous.fingerprint !== fingerprint) {
    const resolved = resolve ? await resolve(previous.key) : null;
    if (['succeeded','not_executed'].includes(resolved?.status)) { delete journal[scope]; localStorage.setItem(storageKey,JSON.stringify(journal)); }
    if (resolved?.status !== 'not_executed') {
    const error = new Error(resolved?.status === 'succeeded' ? 'Önceki isteğiniz kaydedilmiş. Ekranı yenileyip sonucu kontrol edin.' : 'Önceki isteğin sonucu belirsiz. İçeriği değiştirmeden aynı isteği tekrar gönderin.');
    error.response={status:409,data:{message:error.message,code:'unresolved_previous_write'}};
    throw error;
    }
  }
  if (!journal[scope]) { journal[scope] = {fingerprint,key:requestId()}; localStorage.setItem(storageKey, JSON.stringify(journal)); }
  return { key: journal[scope].key, finish: () => { const current = load(); if(current[scope]?.fingerprint===fingerprint)delete current[scope]; localStorage.setItem(storageKey, JSON.stringify(current)); } };
};
